<div class="lp-product-request-info-header">
  <div class="lp-product-request-info-header__wrapper">
    <button
      tuiIconButton
      type="button"
      [appearance]="isDesktop ? 'secondary' : 'icon'"
      [size]="isDesktop ? 'l' : 'm'"
      iconStart="@tui.chevron-left"
      (click)="onClickBackButton()"
    ></button>

    <div class="title">
      <h1>{{ headerTitle }}</h1>
    </div>

    <div *ngIf="mode === 'view'" class="lp-product-request-info-header__action-buttons">
      <button *ngIf="allowedEditing" tuiButton type="button" [size]="tuiElementMediumSize" (click)="startEdit.emit()">
        {{ 'common.buttons.edit' | translate }}
      </button>

      <button
        *ngIf="allowedDeleting"
        tuiButton
        type="button"
        appearance="accent"
        [size]="tuiElementMediumSize"
        (click)="startDelete.emit()"
      >
        {{ 'common.buttons.delete' | translate }}
      </button>
    </div>
  </div>
</div>
